import {
  IBoltTask,
  TaskExecutionTypeFieldSchema,
  useBoltApiClient,
} from "@bolt/core";
import { createBoltTaskApiClient } from "../lib/apiClients/boltTaskApiClient";

export const useTasks = () => {
  const boltApiClient = useBoltApiClient();
  const boltTaskApiClient = createBoltTaskApiClient(boltApiClient);

  const fetchTask = async (taskId: string) => {
    const task = await boltApiClient.get<{ boltTask: IBoltTask }>(
      `task/tasks/${taskId}`
    );
    return task;
  };

  const completeTask = async (
    taskId: string,
    updatedTaskExecutionTypeFields: TaskExecutionTypeFieldSchema
  ) => {
    await boltTaskApiClient.completeTask(
      taskId,
      updatedTaskExecutionTypeFields
    );
  };

  const withdrawTask = async (taskId: string, reason: string) => {
    await boltTaskApiClient.withdrawTask(taskId, reason);
  };

  const reinstateTask = async (taskId: string) => {
    await boltTaskApiClient.reinstateTask(taskId);
  };

  const reassignTask = async (taskId: string, assigneeId: string) => {
    await boltTaskApiClient.reassignTask(taskId, assigneeId);
  };

  return {
    fetchTask,
    completeTask,
    withdrawTask,
    reinstateTask,
    reassignTask,
  };
};
